import { render } from "./KonvaImage.vue?vue&type=template&id=55b8b45e"
import script from "./KonvaImage.vue?vue&type=script&lang=js"
export * from "./KonvaImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__